import script from "./CCCDScanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CCCDScanner.vue?vue&type=script&setup=true&lang=ts"

import "./CCCDScanner.vue?vue&type=style&index=0&id=043b0814&scoped=true&lang=css"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/TTYT_NHS/ZaloOA/ZaloOA_TTYT_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043b0814"]])

export default __exports__